import styled, { css } from "styled-components"
import { respondTo } from "theme/base/Mixins"
import { displays } from "theme/base/Variables"

const TagInfoCustomerStyled = styled.section`
  ${displays.flexWrap};
  margin: 1rem;
  gap: 0.5rem;
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.palette.grey20};
  background: ${({ theme }) => theme.palette.white};

  ${respondTo.sm`
    margin: 1rem auto;
    max-width: 930px
  `}

  & .info-customer {
    ${displays.flexColumn};
    align-items: flex-start;
    gap: 1rem;
  }

  & .secundary-section {
    ${displays.flexColumn};
    gap: 1rem;
    & .qr-code {
      display: flex;
      width: 100%;
      align-self: center;
      justify-content: center;
      align-items: center;
      gap: 3rem;

      & .pending-label {
        display: block;
        color: #ffffff;
        background: #ED1E79;
        font-size: 1.1rem;
        padding: 0 4px;
        margin-bottom: 15px;
        text-align: center;
      }
      
      &.more-qr {
        flex-direction: column-reverse;
        justify-content: space-between;
      }
    }

    & .qr-details {
      text-align: center;
      & .title-code {
        font-size: 1.071rem;
        font-weight: bold;
        margin-top: 1rem;
      }
    }

    & button {
      width: 100%;
    }
  }

  ${respondTo.xs`

    flex-wrap: nowrap;

    & .info-customer {
      width: 50%;
    }
    & .secundary-section {
      justify-content: space-between;
      & .qr-code {
        justify-content: end;

        & .pending-label {
          display: block;
          color: #ffffff;
          background: #ED1E79;
          font-size: 1.1rem;
          padding: 0 4px;
          margin-bottom: 15px;
          text-align: center;
        }

        &.more-qr {
          flex-direction: row;
          align-items: initial;
          gap: 0;
        }
      }
    }
  `}
`

export default TagInfoCustomerStyled

export const printStyled = css`
  @media all {
    * {
      -webkit-print-color-adjust: exact;
    }

    .info-customer {
      .field {
        font-size: 12px;
      }
    }

    .secundary-section button {
      display: none;
    }
  }
`
